"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _config = require("@trs/config");
var _styledComponents = require("styled-components");
var R = _interopRequireWildcard(require("ramda"));
var _ShareDetail = _interopRequireDefault(require("./ShareDetail.style"));
var _Doughnut = _interopRequireDefault(require("../charts/doughnut/Doughnut"));
var _ShareDetailLegend = _interopRequireDefault(require("./ShareDetailLegend"));
var _misc = require("../misc");
var _currency = _interopRequireDefault(require("../currency"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ShareDetail = function ShareDetail(_ref) {
  var name = _ref.name,
    sharePrice = _ref.sharePrice,
    shareData = _ref.shareData,
    priceLabelContent = _ref.priceLabelContent,
    isTimeVisible = _ref.isTimeVisible,
    provider = _ref.provider,
    label = _ref.label,
    theme = _ref.theme,
    employeeCurrency = _ref.employeeCurrency,
    showVested = _ref.showVested,
    showUnvested = _ref.showUnvested;
  return /*#__PURE__*/_react["default"].createElement(_ShareDetail["default"], {
    className: "share-detail-wrapper"
  }, name && /*#__PURE__*/_react["default"].createElement(_misc.Paragraph, {
    className: "container-title"
  }, name), (showUnvested || showVested) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "share-price"
  }, /*#__PURE__*/_react["default"].createElement(_currency["default"], {
    decimals: _config.MAX_DECIMALS,
    currency: R.prop('currency', sharePrice),
    shouldParseFloat: true
  }, R.prop('value', sharePrice)), /*#__PURE__*/_react["default"].createElement("span", null, " / ".concat(label.SHARES_PAGE_GROUP_SINGULAR.toLowerCase()))), isTimeVisible && (showVested || showUnvested) && /*#__PURE__*/_react["default"].createElement("div", {
    key: "last-update",
    className: "last-update"
  }, priceLabelContent), /*#__PURE__*/_react["default"].createElement("section", {
    className: "share-detail__info"
  }, /*#__PURE__*/_react["default"].createElement(_Doughnut["default"], {
    data: shareData,
    labelKey: "shareStatus",
    colors: R.path(['extra', 'sharesColorMap'], theme),
    onItemClick: function onItemClick() {},
    height: 220
  }), /*#__PURE__*/_react["default"].createElement(_ShareDetailLegend["default"], {
    shareData: shareData,
    label: label,
    employeeCurrency: employeeCurrency,
    showVested: showVested,
    showUnvested: showUnvested
  })), /*#__PURE__*/_react["default"].createElement("p", {
    key: "share-detail__caption",
    className: "share-detail__caption"
  }, label.SHARES_PROVIDER_CAPTION.split('%').map(function (item, index) {
    return index % 2 !== 0 ? /*#__PURE__*/_react["default"].createElement("a", {
      key: "".concat(R.prop('name', provider)),
      target: "_blank",
      href: R.prop('url', provider),
      rel: "noreferrer noopener"
    }, R.prop('name', provider)) : item;
  })));
};
ShareDetail.propTypes = {
  /** The app theme */
  theme: _propTypes["default"].shape({}).isRequired,
  /** The name of the share */
  name: _propTypes["default"].string.isRequired,
  /** Information about the share */
  shareData: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  /** Information about price per share */
  sharePrice: _propTypes["default"].shape({}).isRequired,
  priceLabelContent: _propTypes["default"].node,
  isTimeVisible: _propTypes["default"].bool,
  /** Share type provider */
  provider: _propTypes["default"].shape({}).isRequired,
  label: _propTypes["default"].shape({
    SHARES_PAGE_GROUP_SINGULAR: _propTypes["default"].string,
    SHARES_PROVIDER_CAPTION: _propTypes["default"].string
  }).isRequired,
  employeeCurrency: _propTypes["default"].string.isRequired,
  showVested: _propTypes["default"].bool,
  showUnvested: _propTypes["default"].bool
};
ShareDetail.defaultProps = {
  isTimeVisible: false,
  priceLabelContent: {},
  showVested: true,
  showUnvested: true
};
ShareDetail.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ShareDetail",
  "props": {
    "isTimeVisible": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "priceLabelContent": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "showVested": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "showUnvested": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "theme": {
      "description": "The app theme",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "name": {
      "description": "The name of the share",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "shareData": {
      "description": "Information about the share",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": true
    },
    "sharePrice": {
      "description": "Information about price per share",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "provider": {
      "description": "Share type provider",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "label": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "SHARES_PAGE_GROUP_SINGULAR": {
            "name": "string",
            "required": false
          },
          "SHARES_PROVIDER_CAPTION": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    },
    "employeeCurrency": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = (0, _styledComponents.withTheme)(ShareDetail);
exports["default"] = _default;